import * as React from "react";
import type { SVGProps } from "react";
const SvgWind = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 9h8.55c.91 0 1.77-.35 2.42-.98.67-.65 1.05-1.52 1.07-2.46a3.44 3.44 0 0 0-.98-2.49A3.48 3.48 0 0 0 13.61 2h-.07c-1.52 0-2.89 1-3.34 2.46-.16.53.13 1.09.66 1.25a.997.997 0 0 0 1.25-.66c.19-.62.78-1.05 1.43-1.05h.03c.4 0 .78.17 1.05.46.28.29.43.67.42 1.07 0 .4-.17.78-.46 1.05-.29.28-.63.41-1.09.42H5c-.55 0-1 .45-1 1s.45 1 1 1m15.98 2.98c-.67-.65-1.52-.99-2.47-.98H3c-.55 0-1 .45-1 1s.45 1 1 1h15.52c.4 0 .78.14 1.07.42s.45.65.46 1.05c0 .4-.14.78-.42 1.07s-.65.45-1.05.46c-.66-.02-1.26-.42-1.46-1.06a.997.997 0 0 0-1.25-.66c-.53.16-.82.72-.66 1.25a3.51 3.51 0 0 0 3.34 2.46h.07c.93-.02 1.81-.4 2.46-1.07s1-1.56.98-2.49-.4-1.81-1.07-2.46zM4 15h5.5c.92 0 1.81.33 2.48.98s1.05 1.53 1.07 2.46-.33 1.82-.98 2.49A3.48 3.48 0 0 1 9.62 22h-.07c-1.52 0-2.89-1-3.34-2.46a.997.997 0 0 1 .66-1.25c.52-.16 1.09.13 1.25.66.2.63.79 1.05 1.46 1.05.4-.01.77-.17 1.05-.46s.42-.67.42-1.07c-.01-.4-.17-.77-.46-1.05s-.67-.4-1.07-.42H4c-.55 0-1-.45-1-1s.45-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWind;
